import { get } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { moderationColors } from '@/utils'

import sticker from '@/components/sticker'

function renderComment(h, comment, type) {
  if (comment) {
    let commentBorderColor
    if (type === 'adminComment' && comment.length) {
      commentBorderColor = moderationColors[this.value.moderation]
    }

    let commentCopy
    if (type === 'comment') {
      commentCopy = true
    }

    return h(
      sticker,
      {
        props: {
          value: comment,
          label: this.getTranslate(`${Services.sendernames}.labels.meta.${type}`),
          borderStyle: 'dashed',
          borderColor: commentBorderColor,
          copy: commentCopy
        }
      }
    )
  }
}

function renderCommentFromUser(h) {
  if (this.canGetSendernamesAsResellerUp) {
    return renderComment.call(this, h, get(this.value, 'meta.comment'), 'comment')
  }
}

function renderCommentFromAdmin(h) {
  if (this.showCommentFromAdminOrReseller) {
    return renderComment.call(this, h, this.commentFromAdminOrReseller, 'adminComment')
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.sendernames}-item__comments`
    },
    [
      renderCommentFromUser.call(this, h),
      renderCommentFromAdmin.call(this, h)
    ]
  )
}
